import React, { Component } from 'react';
import Game from './components/Game'
import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {

  render() {
    return (
      <Game />
    );
  }
}

export default App;
